import * as PIXI from "pixi.js";

export class CollectableSprite extends PIXI.Sprite {
    isCollected = false;
    isCollectedByFriendly =  true;
}